import 'component/css/payment.css';

import { useState } from 'react';
import API from 'service/api';
import Util, { ActionType } from 'service/util';

import Form from 'component/Form';
import PopMessage from 'component/pop-msg/PopMessage';

const ConfirmChangeLicenseModal = ({ onConfirm, onCancel, customers, ...props }) =>
{
  return (<>
    <p className="message red">車輛已經被其他客戶註冊，是否仍要繼續更改車牌號碼？</p>
    <table className="data-table">
      <thead>
        <tr>
          <th>客戶編號</th>
          <th>登入名稱</th>
          <th>顯示名稱</th>
          <th>建立日期</th>
          <th>修改日期</th>
        </tr>
      </thead>
      <tbody>
        { customers.map(x =>
          <tr key={x.id}>
            <td>{ x.id }</td>
            <td>{ x.login_name }</td>
            <td>{ x.display_name }</td>
            <td>{ Util.FullDate(x.create_dtm) }</td>
            <td>{ Util.FullDate(x.mod_dtm) }</td>
          </tr>
        )}
      </tbody>
    </table>
    <div className="action-panel">
      <button className="btn grey" onClick={onCancel}>取消</button>
      <button className="btn red" onClick={onConfirm}>確定建立</button>
    </div>
  </>);
}

const ChangeLicense = (props) =>
{
  const [new_license, setNewLicense] = useState('');
  const [customers, setCustomers]    = useState(null);

  const submit = (e) =>
  {
    e.preventDefault();
    e.stopPropagation();
    changeLicense(false);
  }

  const changeLicense = (force) =>
  {
    let dto = {
      force,
      action: ActionType.ChangeLicense,
      cd_license: props.vehicle.cd_license,
      owner_id: props.vehicle.owner_id,
      new_license,
    };
    API.changeServiceRecord(dto).then(resp =>
    {
      if (resp.success) {
        PopMessage.show('已成功修改記錄。', '成功', 'success');
        window.location.href = `/op/services/${dto.new_license}/${dto.owner_id}`;
        setCustomers(null);
      } else if ('string' == typeof resp.msg){
        PopMessage.show(resp.msg, '失敗', 'danger');
        setCustomers(null);
      } else {
        setCustomers(resp.msg.customers);
      }
    });

    return false;
  }

  // Confirm
  if (customers)
  {
    return <ConfirmChangeLicenseModal customers={customers} onConfirm={e=>changeLicense(true)} onCancel={e=>setCustomers(null)} />
  }

  return (
    <Form onSubmit={submit}>
      <p className="message red">
        將現有車牌的所有紀錄轉移至新車牌上，如轉移目標車牌已存在並存在已有服務紀錄或賬單，將不能執行此操作。
      </p>
      <label className="field">
        <strong>新車牌</strong>
        <input type="text" required
          value={new_license} onChange={e=>setNewLicense(e.target.value.toUpperCase().trim())} />
      </label>
      <div className="action-panel">
        <div className="dummy"></div>
        <button type="submit" className="btn blue">確定</button>
      </div>
    </Form>
  );
}

export default ChangeLicense;